import {Pipe, PipeTransform} from '@angular/core';
import {ETipoUsuario} from '@core/models';

@Pipe({name: 'tipoUser'})
export class tipoUserPipe implements PipeTransform {
  transform(dato: number): any {
    if (!dato) {
      return dato;
    }

    switch (dato) {
      case ETipoUsuario.ADMINISTRADOR_EMPRESA:
        return 'Administrador Empresa';
      case ETipoUsuario.INSPECTOR:
        return 'Inspector';
      case ETipoUsuario.ADMINISTRADOR_SISTEMA:
        return 'Administrador Sistema';
        case ETipoUsuario.ADMINISTRADOR_INSPECTOR:
        return 'Administrador Inspector';
    }
  }
}
